/* ============================================================
   KBS PRODUKTKARTEN — Verhalten
   ------------------------------------------------------------
   Gegenstueck zu assets/kbs-cards.css.

   PROBLEM: Nach einem Rechtsklick auf eine Produktkarte verhaelt sich
   die Karte, als wuerde man die Maustaste gedrueckt halten — die
   Karten-Slideshow bleibt im Zieh-Modus und folgt der Mausbewegung.

   URSACHE: Die Slideshow startet ihren Drag beim Druecken der Maus,
   ohne die Taste zu pruefen. Ein Rechtsklick startet den Drag also
   mit. Das zugehoerige Loslassen erreicht die Slideshow nie, weil
   stattdessen das Kontextmenue oeffnet und den Pointer uebernimmt —
   der Zieh-Zustand bleibt haengen.

   Aufgefallen erst, seit der Link-Overlay ueber dem Karteninhalt
   liegt (siehe kbs-cards.css); vorher lief der Rechtsklick anders
   durch.

   FIX — zwei Ebenen, weil eine allein nicht gereicht hat:

   1) Blockieren: pointerdown UND mousedown mit nicht-primaerer Taste
      gar nicht erst durchlassen. Ein erster Versuch fasste nur
      pointerdown ab und blieb wirkungslos — die Slideshow haengt
      offenbar am aelteren mousedown. Beide abzudecken kostet nichts.
      stopImmediatePropagation zusaetzlich zu stopPropagation, falls
      ein weiterer Handler am selben Element haengt; dort greift
      stopPropagation naemlich nicht.

   2) Aufloesen: Beim Oeffnen des Kontextmenues kuenstliche
      Loslass-Ereignisse schicken. Das beendet einen Drag, der auf
      anderem Weg doch gestartet ist — etwa weil ein Handler frueher
      registriert wurde als dieser hier.

   Wichtig: NIRGENDS preventDefault. Das wuerde das Kontextmenue
   unterdruecken — also genau die Funktion, die der Link-Overlay
   gerade erst hergestellt hat. stopPropagation blockiert nur andere
   Handler, nicht die Browser-Standardaktion.
   ============================================================ */

(function () {
  'use strict';

  var CARD = '.product-card, .resource-card';

  function inCard(target) {
    return target instanceof Element && !!target.closest(CARD);
  }

  /* --- 1) Nicht-primaere Tasten blockieren ------------------- */
  function blockNonPrimary(event) {
    /* button 0 = primaere Taste. Rechts, mittig und die
       Zurueck/Vorwaerts-Tasten sollen keine Karten-Interaktion
       ausloesen. */
    if (event.button === 0) return;
    if (!inCard(event.target)) return;

    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  document.addEventListener('pointerdown', blockNonPrimary, true);
  document.addEventListener('mousedown', blockNonPrimary, true);

  /* --- 2) Haengenden Drag aufloesen -------------------------- */
  document.addEventListener(
    'contextmenu',
    function (event) {
      if (!inCard(event.target)) return;

      var target = event.target;

      /* Kuenstliches Loslassen an denselben Koordinaten. Beendet
         Drag-Logiken, die bereits gestartet sind. */
      ['pointerup', 'mouseup', 'pointercancel'].forEach(function (type) {
        var Ctor = type.indexOf('pointer') === 0 && window.PointerEvent ? PointerEvent : MouseEvent;
        try {
          target.dispatchEvent(
            new Ctor(type, {
              bubbles: true,
              cancelable: true,
              clientX: event.clientX,
              clientY: event.clientY,
              button: 0,
              buttons: 0
            })
          );
        } catch (e) {
          /* Event-Typ nicht unterstuetzt — naechsten versuchen */
        }
      });

      /* Falls die Slideshow den Pointer eingefangen hat, wieder
         freigeben. Ohne das folgt sie der Maus weiter. */
      if (event.pointerId != null && target.releasePointerCapture) {
        try { target.releasePointerCapture(event.pointerId); } catch (e) { /* nicht gefangen */ }
      }

      document.querySelectorAll(CARD + ' slideshow-component').forEach(function (el) {
        if (!el.releasePointerCapture) return;
        for (var id = 1; id <= 3; id++) {
          try { el.releasePointerCapture(id); } catch (e) { /* nicht gefangen */ }
        }
      });
    },
    true
  );
})();